import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;

export function useStripeLinks() {
  const [state, setState] = useState(
    cache || { appUrl: "", communityUrl: "", loaded: false }
  );

  useEffect(() => {
    if (cache) return;
    let active = true;
    axios
      .get(`${API}/config`)
      .then((res) => {
        if (!active) return;
        cache = {
          appUrl: res.data.stripe_app_checkout_url || "",
          communityUrl: res.data.stripe_community_checkout_url || "",
          loaded: true,
        };
        setState(cache);
      })
      .catch(() => {
        if (active) setState({ appUrl: "", communityUrl: "", loaded: true });
      });
    return () => {
      active = false;
    };
  }, []);

  return state;
}
